module.exports = __webpack_public_path__ + "img/basics_large.f50c34af.png";